"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var theme = require("./theme.scss");
var index_1 = require("../index");
exports.ReportingHistoryHeaders = [{
        label: "Date",
        sortBy: "created",
        searchKey: "created"
    }, {
        label: "Duration",
        sortBy: "duration",
        searchKey: "duration"
    }, {
        label: "Description",
        sortBy: "description",
        searchKey: "description"
    }, {
        label: "Dimensions",
        sortBy: "dimensions",
        searchKey: "dimensions"
    }, {
        label: "Metrics",
        sortBy: "metrics",
        searchKey: "metrics"
    }, {
        label: "Filters",
        sortBy: "filtersStr",
        searchKey: "filtersStr"
    }, {
        label: "Constraints",
        sortBy: "constraintsStr",
        searchKey: "constraintsStr"
    }, {
        label: "Size",
        sortBy: "size",
        searchKey: "size"
    }, {
        label: "Execution Time",
        sortBy: "executionTime",
        searchKey: "executionTime"
    }, {
        label: "Actions",
    }, {
        label: "Status",
        sortBy: "status",
        searchKey: "status"
    }];
var ReportingHistory = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingHistory, _super);
    function ReportingHistory(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.renderHeaderAndFooter = function (scrollTop, scrollLeft, columnsWidth, setFreezeColumn, freezeColumnIndex) {
            var _a = _this.props, sortDirection = _a.sortDirection, setSearchQuery = _a.setSearchQuery, sortBy = _a.sortBy, sort = _a.sort, searchQueries = _a.searchQueries;
            return (React.createElement(ui_1.DataGridRow, { columnsWidth: columnsWidth }, exports.ReportingHistoryHeaders.map(function (header) {
                var props = {
                    blue: true,
                    label: header.label,
                    sortable: !!header.sortBy,
                    sortBy: header.sortBy,
                    sortActive: sortBy === header.sortBy,
                    searchKey: header.searchKey,
                    searchable: !!header.searchKey,
                    searchQuery: searchQueries[header.searchKey || ""],
                    freezeColumnIndex: freezeColumnIndex,
                    columnsWidth: columnsWidth,
                    setFreezeColumn: setFreezeColumn,
                    sortDirection: sortDirection,
                    onSort: sort,
                    onSearch: setSearchQuery,
                };
                return (React.createElement(ui_1.DataGridHeaderColumn, tslib_1.__assign({ key: header.label }, props)));
            })));
        };
        _this.renderRow = function (index, viewportIndex, columnsWidth, freezeColumnIndex) {
            var _a = _this.props, items = _a.items, sortBy = _a.sortBy, selectedValues = _a.selectedValues, getReportFromReportingHistoryUrls = _a.getReportFromReportingHistoryUrls, setParamsFromHistoryReport = _a.setParamsFromHistoryReport;
            var item = items[index];
            return (React.createElement(index_1.ReportHistoryRow, { isSelected: selectedValues.indexOf(item._id) > -1, key: item._id, item: item, sortBy: sortBy, columnsWidth: columnsWidth, freezeColumnIndex: freezeColumnIndex, index: index, setEditHistoryReport: _this.props.setEditHistoryReport, getReportFromReportingHistoryUrls: getReportFromReportingHistoryUrls, setParamsFromHistoryReport: setParamsFromHistoryReport }));
        };
        _this.onColumnResize = function (columnsWidth) {
            _this.props.setColumnsWidth(columnsWidth);
        };
        return _this;
    }
    ReportingHistory.prototype.render = function () {
        var _a = this.props, items = _a.items, getColumnsWidth = _a.getColumnsWidth;
        var columnsWidth = getColumnsWidth();
        return (React.createElement(ui_1.DataGrid, { onColumnResize: this.onColumnResize, className: theme.list, extraData: items, headersCount: exports.ReportingHistoryHeaders.length, itemsCount: items.length, renderRow: this.renderRow, rowHeight: 40, columnsWidth: columnsWidth, renderHeader: this.renderHeaderAndFooter }));
    };
    return ReportingHistory;
}(React.Component));
exports.default = ReportingHistory;
